import styled from 'styled-components';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Colors } from '../../../theme';
import { body1, button, fontRegular16 } from '../styles/fonts';
export const Wrapper = styled.section `
  display: flex;
  align-items: center;
`;
export const AvatarName = styled(Avatar) `
  &.MuiAvatar-root {
    margin-right: 8px;
    color: ${Colors.blue60};
    background-color: ${Colors.blue10};
    ${fontRegular16};
  }
`;
export const FullName = styled(Typography) `
  &.MuiTypography-root.MuiTypography-body1 {
    padding: 0;
    width: 100%;
    display: block;
    text-align: left;
    margin-bottom: 8px;
    color: ${Colors.grey900};
    ${button};
  }
`;
export const Iban = styled(Typography) `
  &.MuiTypography-root.MuiTypography-body1 {
    color: ${Colors.grey500};
    ${body1};
  }
`;
export const Container = styled.div `
  flex: 1;
`;
export const AccountWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const AccountLabel = styled.div `
  ${fontRegular16};
  color: ${Colors.black80};
`;
export const AccountId = styled.div `
  display: flex;
  align-items: center;
  ${fontRegular16};
  color: ${Colors.black80};

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${Colors.blue300};
    outline-offset: 2px;
  }
`;
export const CopyIconButton = styled(Button) `
  &.MuiButtonBase-root.MuiButton-root {
    min-width: 24px;
    padding: 0;

    &:hover {
      background-color: transparent;

      path {
        stroke: ${Colors.blue400};
      }
    }
  }

  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  &:focus-visible,
  &.Mui-focusVisible {
    outline: 2px solid ${Colors.blue300};
    outline-offset: 2px;
  }
`;
//# sourceMappingURL=styles.js.map